import { getExperiment, logEvent, updateUser } from '@eventbrite/statsig';
import { Dispatch } from 'redux';
import {
    STATSIG_INTERSTITIAL_LOGIN_PARAM,
    STATSIG_LOGIN_INTERSTITIAL_EXPERIMENT_KEY,
} from '../constants/statsig';
import { isStatsigFreeTrialEnabledForInterstitialLogin } from '../selectors/statsig';
import { getLoginFromCheckoutPage, isUserLoggedIn } from '../selectors/user';
import { CheckoutState } from '../state';
import { Experiment } from '../state/statsig';
import { getStatsigConfig } from '../utils/statsig';

export const isLoginInterstitialEnabled = () => async (
    _: Dispatch<CheckoutState>,
    getState: () => CheckoutState,
) => {
    const state = getState();
    if (
        isUserLoggedIn(state) ||
        !isStatsigFreeTrialEnabledForInterstitialLogin(state)
    ) {
        return false;
    }

    return getExperiment(
        STATSIG_LOGIN_INTERSTITIAL_EXPERIMENT_KEY,
        STATSIG_INTERSTITIAL_LOGIN_PARAM,
        false,
    );
};

export const updateExperimentUser = () => async (
    _: Dispatch<CheckoutState>,
    getState: () => CheckoutState,
) => await updateUser(getStatsigConfig(getState()));

export const logLoginInterstitialEvent = (eventName: string) => (
    _: Dispatch<CheckoutState>,
    getState: () => CheckoutState,
) => {
    const state = getState();
    logEvent(eventName, null, {
        isInterstitialStep: `${!getLoginFromCheckoutPage(state)}`,
    });
};

export enum StatsigActionType {
    saveExperimentData = 'saveExperimentData',
}

export interface SaveExperimentDataAction {
    type: StatsigActionType.saveExperimentData;
    payload: Experiment;
}
export const saveExperimentDataAction = (
    experiment: Experiment,
): SaveExperimentDataAction => ({
    type: StatsigActionType.saveExperimentData,
    payload: experiment,
});

export type StatsigAction = SaveExperimentDataAction;
